import type { ListAuditTemplatesCommandInput } from '@amzn/gbsa-helios-typescript-client';

export const v2TemplateKeys = {
  all: ['v2', 'templates'] as const,
  lists: () => [...v2TemplateKeys.all, 'list'] as const,
  list: (filters: Partial<ListAuditTemplatesCommandInput>) =>
    [...v2TemplateKeys.lists(), filters] as const,
};
